<mat-form-field>
  <mat-label>{{ 'categories.form.iconKey' | transloco }}</mat-label>
  <mat-select
    [value]="value"
    [disabled]="disabled"
    (selectionChange)="onSelectionChange($event.value)"
    (closed)="onClosed()"
  >
    <mat-select-trigger>
      <span class="icon-select-value">
        <mat-icon aria-hidden="true">{{ selectedOption.key }}</mat-icon>
        <span>
          @if (selectedOption.labelKey) {
            {{ selectedOption.labelKey | transloco }}
          } @else {
            {{ selectedOption.key }}
          }
        </span>
      </span>
    </mat-select-trigger>

    @for (option of selectableOptions; track option.key) {
      <mat-option [value]="option.key">
        <span class="icon-select-option">
          <mat-icon aria-hidden="true">{{ option.key }}</mat-icon>
          <span class="icon-select-option-text">
            <span>
              @if (option.labelKey) {
                {{ option.labelKey | transloco }}
              } @else {
                {{ option.key }}
              }
            </span>
            <small>{{ option.key }}</small>
          </span>
        </span>
      </mat-option>
    }
  </mat-select>
  <mat-hint>{{ 'categories.form.iconHint' | transloco }}</mat-hint>
  @if (showRequiredError) {
    <mat-error>{{ 'categories.form.iconRequired' | transloco }}</mat-error>
  }
</mat-form-field>
